import { HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";
import "./actions.scss";

export const JournalSectionActions = ({
  children,
  className,
  ...rest
}: { children: ReactNode } & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={clsx("journal-section-actions", className)} {...rest}>
      {children}
    </div>
  );
};
